export default __webpack_public_path__ + "static/media/ability-hashtag.22609321.png";